<template>
  <div v-if="mostrar" class="modal-overlay" @click.self="fechar">
    <div class="config-modal">
      <!-- Header -->
      <div class="config-header">
        <h2>Configurações</h2>
        <button class="btn-fechar" @click="fechar">&times;</button>
      </div>

      <!-- Abas -->
      <div class="config-tabs">
        <button
          v-for="aba in abas"
          :key="aba.id"
          :class="['tab-btn', { 'tab-ativa': abaAtiva === aba.id }]"
          @click="abaAtiva = aba.id"
        >
          <span class="tab-icon">{{ aba.icon }}</span>
          <span class="tab-label">{{ aba.label }}</span>
        </button>
      </div>

      <!-- Conteúdo das Abas -->
      <div class="config-body">
        <!-- ABA 1: Perfil do Usuário -->
        <div v-show="abaAtiva === 'perfil'" class="aba-conteudo">
          <h3>Perfil do Usuário</h3>
          <div class="form-group">
            <label>Nome</label>
            <input
              v-model="perfil.name"
              type="text"
              class="form-input"
              placeholder="Seu nome"
            />
          </div>
          <div class="form-group">
            <label>Email</label>
            <input
              v-model="perfil.email"
              type="email"
              class="form-input"
              placeholder="seu@email.com"
            />
          </div>
          <div class="form-group">
            <label>Nova Senha</label>
            <input
              v-model="perfil.password"
              type="password"
              class="form-input"
              placeholder="Deixe vazio para não alterar"
            />
          </div>
          <div class="form-group">
            <label>Confirmar Senha</label>
            <input
              v-model="perfil.password_confirmation"
              type="password"
              class="form-input"
              placeholder="Confirme a nova senha"
            />
          </div>
          <button class="btn-salvar" @click="salvarPerfil">Salvar Perfil</button>
        </div>

        <!-- ABA 2: Preferências do Usuário -->
        <div v-show="abaAtiva === 'preferencias'" class="aba-conteudo">
          <h3>Preferências</h3>
          <div class="form-group">
            <label>Tema</label>
            <select v-model="preferencias.tema" class="form-input">
              <option value="claro">Claro</option>
              <option value="escuro">Escuro</option>
            </select>
          </div>
          <div class="form-group">
            <label>Itens por página</label>
            <select v-model="preferencias.itensPorPagina" class="form-input">
              <option :value="10">10</option>
              <option :value="25">25</option>
              <option :value="50">50</option>
              <option :value="100">100</option>
            </select>
          </div>
          <div class="form-group">
            <label>Formato de Data</label>
            <select v-model="preferencias.formatoData" class="form-input">
              <option value="DD/MM/YYYY">DD/MM/AAAA</option>
              <option value="YYYY-MM-DD">AAAA-MM-DD</option>
              <option value="MM/DD/YYYY">MM/DD/AAAA</option>
            </select>
          </div>
          <div class="form-group">
            <label>Idioma</label>
            <select v-model="preferencias.idioma" class="form-input">
              <option value="pt-BR">Português (Brasil)</option>
              <option value="en">English</option>
              <option value="es">Español</option>
            </select>
          </div>
          <button class="btn-salvar" @click="salvarPreferencias">Salvar Preferências</button>
        </div>

        <!-- ABA 3: Tabelas Auxiliares -->
        <div v-show="abaAtiva === 'tabelas'" class="aba-conteudo">
          <TabelasAuxiliares />
        </div>

        <!-- ABA 4: Configuração de API -->
        <div v-show="abaAtiva === 'api'" class="aba-conteudo">
          <h3>API de Importação</h3>
          <p class="descricao-aba">
            Configure a API para importação de dados de pacientes via POST de sistemas externos.
          </p>

          <div class="api-info-box">
            <div class="form-group">
              <label>Endpoint</label>
              <div class="input-copiavel">
                <input
                  type="text"
                  class="form-input"
                  :value="api.endpoint"
                  readonly
                />
                <button class="btn-copiar" @click="copiar(api.endpoint)">Copiar</button>
              </div>
            </div>

            <div class="form-group">
              <label>Método</label>
              <input
                type="text"
                class="form-input"
                value="POST"
                readonly
              />
            </div>

            <div class="form-group">
              <label>Token de Acesso (Bearer)</label>
              <div v-if="api.token" class="input-copiavel">
                <input
                  :type="api.mostrarToken ? 'text' : 'password'"
                  class="form-input"
                  :value="api.token"
                  readonly
                />
                <button class="btn-copiar" @click="api.mostrarToken = !api.mostrarToken">
                  {{ api.mostrarToken ? '🙈' : '👁️' }}
                </button>
                <button class="btn-copiar" @click="copiar(api.token)">Copiar</button>
              </div>
              <p v-else-if="api.hasToken" class="descricao-aba">
                Token configurado. Gere um novo para visualizar.
              </p>
              <p v-else class="descricao-aba">
                Nenhum token gerado. Clique abaixo para gerar.
              </p>
            </div>

            <button class="btn-gerar-token" @click="gerarNovoToken">Gerar Novo Token</button>
          </div>

          <div class="api-docs">
            <h4>Como usar</h4>
            <div class="code-block">
              <pre>POST {{ api.endpoint }}
Content-Type: application/json
Authorization: Bearer SEU_TOKEN

{
  "primeiro_nome": "Maria",
  "sobrenome": "Silva",
  "dn": "1990-03-15",
  "sexo": "F",
  "idade": 35,
  "indicacao_clinica": "Emagrecimento",
  "sistema_inscrito": "OUTROS",
  "uf": "DF",
  "email": "maria@email.com",
  "telefone_formatado": "(61) 99999-9999",
  "receber_email": true,
  "receber_whatsapp": true
}</pre>
            </div>

            <h4>Exemplo cURL</h4>
            <div class="code-block">
              <pre>curl -X POST {{ api.endpoint }} \
  -H "Content-Type: application/json" \
  -H "Authorization: Bearer SEU_TOKEN" \
  -d '{"primeiro_nome":"Maria","sobrenome":"Silva","email":"maria@email.com","telefone_formatado":"(61)99999-9999","sexo":"F","sistema_inscrito":"OUTROS"}'</pre>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import axios from 'axios';
import Swal from 'sweetalert2';
import TabelasAuxiliares from './TabelasAuxiliares.vue';

defineProps({
  mostrar: { type: Boolean, default: false }
});

const emit = defineEmits(['fechar', 'preferencias-atualizadas']);

const abaAtiva = ref('perfil');

const abas = [
  { id: 'perfil', label: 'Perfil', icon: '👤' },
  { id: 'preferencias', label: 'Preferências', icon: '⚙️' },
  { id: 'tabelas', label: 'Tabelas', icon: '📊' },
  { id: 'api', label: 'API', icon: '🔗' },
];

// --- Estado: Perfil ---
const perfil = ref({
  name: '',
  email: '',
  password: '',
  password_confirmation: ''
});

// --- Estado: Preferências ---
const preferencias = ref({
  tema: localStorage.getItem('darkMode') === 'true' ? 'escuro' : 'claro',
  itensPorPagina: parseInt(localStorage.getItem('itensPorPagina') || '25'),
  formatoData: localStorage.getItem('formatoData') || 'DD/MM/YYYY',
  idioma: localStorage.getItem('idioma') || 'pt-BR'
});

// --- Estado: API ---
const api = ref({
  endpoint: `${window.location.origin}/api/pacientes`,
  token: '',
  hasToken: false,
  mostrarToken: false
});

// --- Ações ---

const fechar = () => {
  emit('fechar');
};

const copiar = async (texto) => {
  try {
    await navigator.clipboard.writeText(texto);
    Swal.fire({
      icon: 'success',
      title: 'Copiado!',
      timer: 1000,
      showConfirmButton: false
    });
  } catch {
    // Fallback
    const input = document.createElement('input');
    input.value = texto;
    document.body.appendChild(input);
    input.select();
    document.execCommand('copy');
    document.body.removeChild(input);
    Swal.fire({ icon: 'success', title: 'Copiado!', timer: 1000, showConfirmButton: false });
  }
};

// Perfil
const carregarPerfil = async () => {
  try {
    const response = await axios.get('/api/configuracoes/perfil', {
      headers: { Accept: 'application/json' }
    });
    perfil.value.name = response.data.name || '';
    perfil.value.email = response.data.email || '';
  } catch {
    // Silencioso na carga
  }
};

const salvarPerfil = async () => {
  try {
    const dados = { name: perfil.value.name, email: perfil.value.email };
    if (perfil.value.password) {
      dados.password = perfil.value.password;
      dados.password_confirmation = perfil.value.password_confirmation;
    }
    await axios.put('/api/configuracoes/perfil', dados, {
      headers: { Accept: 'application/json' }
    });
    perfil.value.password = '';
    perfil.value.password_confirmation = '';
    Swal.fire({ icon: 'success', title: 'Perfil salvo!', timer: 1500, showConfirmButton: false });
  } catch (error) {
    Swal.fire({ icon: 'error', title: 'Erro', text: error.response?.data?.message || 'Erro ao salvar perfil' });
  }
};

// Preferências
const salvarPreferencias = () => {
  localStorage.setItem('itensPorPagina', preferencias.value.itensPorPagina);
  localStorage.setItem('formatoData', preferencias.value.formatoData);
  localStorage.setItem('idioma', preferencias.value.idioma);

  const isDark = preferencias.value.tema === 'escuro';
  localStorage.setItem('darkMode', isDark);
  if (isDark) {
    document.body.classList.add('dark-mode');
  } else {
    document.body.classList.remove('dark-mode');
  }

  emit('preferencias-atualizadas', preferencias.value);
  Swal.fire({ icon: 'success', title: 'Preferências salvas!', timer: 1500, showConfirmButton: false });
};

// API Token
const gerarNovoToken = async () => {
  const confirmacao = await Swal.fire({
    title: 'Gerar novo token?',
    text: 'O token atual será invalidado. Sistemas externos precisarão ser atualizados.',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Sim, gerar',
    cancelButtonText: 'Cancelar'
  });

  if (!confirmacao.isConfirmed) return;

  try {
    const response = await axios.post('/api/configuracoes/token', {}, {
      headers: { Accept: 'application/json' }
    });
    api.value.token = response.data.token;
    api.value.hasToken = true;
    Swal.fire({ icon: 'success', title: 'Token gerado!', text: 'Copie o token agora. Ele não será exibido novamente.', timer: 4000, showConfirmButton: true });
  } catch (_error) {
    Swal.fire({ icon: 'error', title: 'Erro', text: 'Não foi possível gerar o token' });
  }
};

// API Token info
const carregarToken = async () => {
  try {
    const response = await axios.get('/api/configuracoes/token', {
      headers: { Accept: 'application/json' }
    });
    api.value.hasToken = response.data.has_token;
  } catch {
    // Silencioso
  }
};

// Carregar dados ao montar
onMounted(() => {
  carregarPerfil();
  carregarToken();
});
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.config-modal {
  background: white;
  border-radius: 12px;
  width: 95%;
  max-width: 700px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
}

.dark-mode .config-modal {
  background: #1e1e1e;
  color: #f1f1f1;
}

/* Header */
.config-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid #e0e0e0;
  flex-shrink: 0;
}

.dark-mode .config-header {
  border-bottom-color: #333;
}

.config-header h2 {
  margin: 0;
  font-size: 18px;
}

.btn-fechar {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
}

.dark-mode .btn-fechar {
  color: #aaa;
}

/* Tabs */
.config-tabs {
  display: flex;
  overflow-x: auto;
  border-bottom: 1px solid #e0e0e0;
  background: #f9f9f9;
  flex-shrink: 0;
}

.dark-mode .config-tabs {
  background: #252525;
  border-bottom-color: #333;
}

.tab-btn {
  flex: 1;
  min-width: 80px;
  padding: 12px 8px;
  border: none;
  background: transparent;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  transition: all 0.2s;
  border-bottom: 3px solid transparent;
  color: #666;
  font-size: 12px;
}

.dark-mode .tab-btn {
  color: #aaa;
}

.tab-btn:hover {
  background: #f0f0f0;
}

.dark-mode .tab-btn:hover {
  background: #333;
}

.tab-ativa {
  color: #4caf50;
  border-bottom-color: #4caf50;
  font-weight: 600;
}

.dark-mode .tab-ativa {
  color: #66bb6a;
  border-bottom-color: #66bb6a;
}

.tab-icon {
  font-size: 20px;
}

.tab-label {
  white-space: nowrap;
}

/* Body */
.config-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.aba-conteudo h3 {
  margin: 0 0 15px 0;
  font-size: 16px;
  color: #333;
}

.dark-mode .aba-conteudo h3 {
  color: #f1f1f1;
}

.descricao-aba {
  color: #666;
  font-size: 13px;
  margin-bottom: 20px;
}

.dark-mode .descricao-aba {
  color: #aaa;
}

/* Formulários */
.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #555;
  margin-bottom: 5px;
}

.dark-mode .form-group label {
  color: #ccc;
}

.form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  background: white;
  color: #333;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #4caf50;
}

.dark-mode .form-input {
  background: #2a2a2a;
  color: #f1f1f1;
  border-color: #444;
}

.dark-mode .form-input:focus {
  border-color: #66bb6a;
}

/* Input copiável */
.input-copiavel {
  display: flex;
  gap: 8px;
}

.input-copiavel .form-input {
  flex: 1;
}

.btn-copiar {
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #f5f5f5;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
  transition: background 0.2s;
}

.btn-copiar:hover {
  background: #e8e8e8;
}

.dark-mode .btn-copiar {
  background: #333;
  border-color: #444;
  color: #f1f1f1;
}

.dark-mode .btn-copiar:hover {
  background: #444;
}

/* Botões */
.btn-salvar {
  padding: 10px 24px;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-salvar:hover {
  background: #388e3c;
}

.btn-gerar-token {
  padding: 10px 24px;
  background: #ff9800;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
  transition: background 0.2s;
  margin-top: 10px;
}

.btn-gerar-token:hover {
  background: #f57c00;
}

/* API Docs */
.api-info-box {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  margin-bottom: 20px;
}

.dark-mode .api-info-box {
  background: #252525;
  border-color: #333;
}

.api-docs h4 {
  margin: 15px 0 8px 0;
  font-size: 14px;
  color: #555;
}

.dark-mode .api-docs h4 {
  color: #ccc;
}

.code-block {
  background: #1e1e1e;
  color: #d4d4d4;
  padding: 12px;
  border-radius: 6px;
  overflow-x: auto;
  font-size: 12px;
}

.code-block pre {
  margin: 0;
  white-space: pre-wrap;
  word-break: break-all;
}

.dark-mode .code-block {
  background: #111;
}

/* Responsivo */
@media (max-width: 600px) {
  .config-modal {
    width: 100%;
    height: 100%;
    max-height: 100vh;
    border-radius: 0;
  }

  .tab-btn {
    min-width: 60px;
    padding: 10px 4px;
  }

  .tab-label {
    font-size: 10px;
  }

  .tab-icon {
    font-size: 18px;
  }
}
</style>
